"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var defaults_1 = require("../defaults/defaults");
var logger_1 = require("../log/logger");
function similarTo(key, path) {
    return path.split('.').filter(function (p) {
        return lodash_1.camelCase(key) === lodash_1.camelCase(p);
    }).length > 0;
}
exports.similarTo = similarTo;
function checkDate(value, coerceNumbersToDates) {
    if (coerceNumbersToDates === void 0) { coerceNumbersToDates = false; }
    return lodash_1.isDate(value) || [].concat((!coerceNumbersToDates &&
        (!value ||
            typeof value === 'number' ||
            typeof value === 'boolean')) ?
        undefined :
        new Date(value)).map(function (possibleDate) {
        return (possibleDate && !isNaN(possibleDate.getTime())) ?
            possibleDate : undefined;
    }).shift();
}
exports.checkDate = checkDate;
function isDate(value, coerceNumbersToDate) {
    if (coerceNumbersToDate === void 0) { coerceNumbersToDate = false; }
    return !!checkDate(value, coerceNumbersToDate);
}
exports.isDate = isDate;
function getJSType(val) {
    if (lodash_1.isArray(val))
        return 'array';
    if (isDate(val))
        return 'date';
    return typeof val;
}
function setOnPath(parent, path, value, stomp, current) {
    if (stomp === void 0) { stomp = false; }
    if (current === void 0) { current = parent; }
    var val = fLast(path.split('.'));
    var setFirst = function () {
        var firstVal = current[val.first];
        var firstType = getJSType(value);
        var stompValue = defaults_1.isDefaultOrStompable(current, val.first) || stomp;
        if (stompValue) {
            var name_1 = current.constructor.name || 'Non-class object';
            logger_1.Log.warn("Overriding value found at property '" + val.first + "' " +
                ("on " + name_1 + ".\nCurrent: '" + current[val.first] + "'") +
                ("\nNew: '" + value + "'"));
        }
        switch (firstType) {
            case 'array':
                current[val.first] = (stompValue) ? value : firstVal.concat(value);
                break;
            case 'string':
            case 'boolean':
            case 'number':
            case 'date':
            case 'object':
                current[val.first] = (stompValue) ? value : firstVal;
                break;
        }
    };
    if (val.last.length) {
        if (typeof current[val.first] !== 'boolean' &&
            !current[val.first]) {
            current[val.first] = {};
            defaults_1.setDefault(current, val.first);
        }
        if (typeof current[val.first] === 'object') {
            setOnPath(parent, val.last.join('.'), value, stomp, current[val.first]);
        }
    }
    else {
        setFirst();
    }
    return parent;
}
exports.setOnPath = setOnPath;
function getValueFromString(obj, path) {
    var val = fLast(path.split('.'));
    return (val.last.length) ?
        getValueFromString(obj[val.first], val.last.join('.')) :
        obj[val.first];
}
exports.getValueFromString = getValueFromString;
function fLast(arr) {
    return {
        first: lodash_1.head(arr),
        last: lodash_1.tail(arr)
    };
}
exports.fLast = fLast;
//# sourceMappingURL=utils.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/get-or/dist/util/utils.js
 ** module id = 403
 ** module chunks = 0
 **/